import { render, staticRenderFns } from "./AddPermissionModal.vue?vue&type=template&id=27e3c126&scoped=true&"
import script from "./AddPermissionModal.vue?vue&type=script&lang=js&"
export * from "./AddPermissionModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPermissionModal.vue?vue&type=style&index=0&id=27e3c126&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e3c126",
  null
  
)

export default component.exports